/**
 * Time budget for one measurement activate/deactivate round trip (D7-7986)
 *
 * Plain terms
 * -----------
 * When the scoring form switches a lesion's tool on, D7 asks the viewer and
 * waits for the answer. A viewer that is still starting up may first wait for
 * its image area to appear, then for the lesion's slice to be drawn. D7 has to
 * wait longer than both together — otherwise it reports a failure for a tool
 * the viewer switches on a moment later — and still answer the form before the
 * form gives up on its own.
 *
 * Technical
 * ---------
 * The viewer's `handleMeasurementActivate` waits up to `VIEWPORT_GRID_WAIT_MS`
 * in `waitForViewportGrid`; `activateToolWorker` may then wait up to
 * `NAVIGATION_RENDER_WAIT_MS` in `activateSeriesWithMeasurement`. D7's
 * `activateDeactivateMeasurementsWorker` gives the viewer request
 * `ACTIVATE_DEACTIVATE_TIMEOUT_MS` — both waits plus `ARMING_MARGIN_MS` — which
 * must stay below `FORM_REQUEST_TIMEOUT_MS`, the rpc-core default
 * (`JsonRpcPeer`'s `defaultTimeoutMs`) the scoring form calls D7 with.
 * `measurementActivation.test.ts` pins both relations.
 */
export const VIEWPORT_GRID_WAIT_MS = 3000;

export const NAVIGATION_RENDER_WAIT_MS = 3000;

const ARMING_MARGIN_MS = 2000;

export const ACTIVATE_DEACTIVATE_TIMEOUT_MS =
  VIEWPORT_GRID_WAIT_MS + NAVIGATION_RENDER_WAIT_MS + ARMING_MARGIN_MS;

export const FORM_REQUEST_TIMEOUT_MS = 15000;
